import React, { lazy, Suspense } from 'react';

const LazyLeadsPage = lazy(() => import('./LeadsPage'));

const LeadsPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyLeadsPage {...props} />
  </Suspense>
);

export default LeadsPage;
